var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2.76318H10C8.89543 2.76318 8 3.65861 8 4.76318V28.7632C8 29.8678 8.89543 30.7632 10 30.7632H22C23.1046 30.7632 24 29.8678 24 28.7632V4.76318C24 3.65861 23.1046 2.76318 22 2.76318ZM10 0.763184C7.79086 0.763184 6 2.55404 6 4.76318V28.7632C6 30.9723 7.79086 32.7632 10 32.7632H22C24.2091 32.7632 26 30.9723 26 28.7632V4.76318C26 2.55404 24.2091 0.763184 22 0.763184H10Z",
    fill: "#101225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.7632C17.1046 28.7632 18 27.8678 18 26.7632C18 25.6586 17.1046 24.7632 16 24.7632C14.8954 24.7632 14 25.6586 14 26.7632C14 27.8678 14.8954 28.7632 16 28.7632Z",
    fill: "#101225"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNew);
export default __webpack_public_path__ + "static/media/PhoneNew.6068b81cb0dc27bc3ec11c8f527c3063.svg";
export { ForwardRef as ReactComponent };